import { OG_AVAILABLE } from './ogManifest';

// Shared fallback used whenever a page has no dedicated OG image yet.
export const DEFAULT_OG_IMAGE = 'https://210tattoo.gr/og-image.png';

const available = new Set(OG_AVAILABLE);

/**
 * Resolve the og:image / twitter:image URL for a page.
 *
 * Pass a page slug (e.g. "fine-line-tattoo-athens" or "tattoo-healing-time-athens")
 * to use its dedicated https://210tattoo.gr/og/<slug>.png when that file exists in
 * public/og/. If the image is missing (the common case until real photos are
 * dropped in) it falls back to the shared /og-image.png so nothing 404s.
 *
 * Availability is baked at build time — regenerate with `npm run og:manifest`
 * after adding or removing images in public/og/.
 */
export function ogImage(slug?: string): string {
  if (slug && available.has(slug)) return `https://210tattoo.gr/og/${slug}.png`;
  return DEFAULT_OG_IMAGE;
}
